<!-- <div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
    <button (click)="cerrar();" type="button" class="close pt-2 z-3" style="position: relative;" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="modal-body">
      <div class="card">
          <div class="card-header card-header-icon card-header-rose"> -->
<!--             <div class="card-icon">
              <i class="material-icons"></i>
            </div> -->
<!--             <h4 class="card-title text-center font-weight-bold">Delegate Clients</h4>
          </div>
          <div class="card-body">

<div mat-dialog-content>

     <form #userNewForm="ngForm">
                  <div class="row">
                    <div class="col-md-12">
                      <mat-form-field class="small-form-field">
                        <input class="text-dark" type="text" matInput [(ngModel)]="this.name"  placeholder="{{this.user.user.name}} {{this.user.user.surname}}"  disabled>
                        <mat-label>Rep Name</mat-label>
                      </mat-form-field> -->
<!--                   <div class="form-group">
                    <label class="bmd-label-floating">REP Name</label>
                    <input type="text" class="form-control"  placeholder="{{this.user.user.name}} {{this.user.user.surname}}"  disabled>
                  </div> -->
                <!--   <div  class="form-group" *ngIf="loading == false"> -->
                 
 <!-- <label class="bmd-label-floating">Delegate Clients To:</label> -->
                        <!--          <mat-form-field class="example-full-width">
                                  <mat-label>Delegate Clients To:</mat-label>
    <input type="text" [(ngModel)]="this.user.new_user" placeholder="Select"  aria-label="Select" matInput [formControl]="myControlClientes" [matAutocomplete]="autoClientes" id="nameCliente">
    <mat-autocomplete  #autoClientes="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let option of filteredClientes | async" [value]="option">
        
        {{option.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <div class="d-flex justify-content-end">
    <button matRipple class="gts-btn-primary mt-2 mb-2 btn-cancel" [mat-dialog-close]="this.user">
      <span class="gts-btn-text">Save Changes</span>
    </button>
  </div>


                  </div>
                  <mat-progress-bar style="width: 80%" *ngIf="loading" id="loadingbar" mode="indeterminate"></mat-progress-bar>
                </div>
              
               <div mat-dialog-actions>
 -->
 <!--  <button mat-button class="btn btn-success" [mat-dialog-close]="this.user" cdkFocusInitial>Do it!</button> -->
<!-- </div>
              </div>

              
    
          
             
              <div class="row">
                
               
                
              </div>
         
                </form>
                
  </div>
      </div>
  </div>
</div>
</div>

 

</div>

 
<div> -->

<!-- /// -->
<div class="main-content">
  <div class="pr-2">
    <button (click)="cerrar();" type="button" class="close pt-2 z-3" style="position: relative;" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
    <div class="d-flex justify-content-center">
    <h2 mat-dialog-title>Delegate Clients</h2>
    </div>
  <mat-dialog-content>
    <form>
      <mat-form-field class="small-form-field">
        <input class="text-dark" type="text" matInput [(ngModel)]="this.name"  placeholder="{{this.user.user.name}} {{this.user.user.surname}}"  disabled>
        <mat-label>Rep Name</mat-label>
      </mat-form-field>
      <mat-form-field class="example-full-width">
         <mat-label>Delegate Clients To:</mat-label>
            <input type="text" [(ngModel)]="this.user.new_user" placeholder="Select"  aria-label="Select" matInput [formControl]="myControlClientes" [matAutocomplete]="autoClientes" id="nameCliente">
              <mat-autocomplete  #autoClientes="matAutocomplete" [displayWith]="displayFn">
                  <mat-option *ngFor="let option of filteredClientes | async" [value]="option">

                      {{option.name}}
                  </mat-option>
                </mat-autocomplete>
            </mat-form-field>

    </form>
  </mat-dialog-content>
  <mat-dialog-actions>

  </mat-dialog-actions>
  <div class="d-flex justify-content-end pb-2 pr-2">
    <button class="gts-btn-primary" matRipple  [mat-dialog-close]="this.user" cdkFocusInitial>Save Changes</button>
    </div>
</div>